import React from 'react'
import GetRequest from '../Services/APIRequest'
import Loading from '../Components/Loading'
import Error from '../Components/Error'
import ss3 from '../Assets/img/Schemes/ss3.png'  // fallback image

const SOCIAL_URLS = {
  instagram: 'https://instagram.com/juiceathome',
  twitter: 'https://twitter.com/juiceathome',
  facebook: 'https://facebook.com/juiceathome',
  linkedin: 'https://linkedin.com/company/juiceathome',
  youtube: 'https://youtube.com/channel/YourChannelID'
}

// A small palette of accent colors for cards
const CARD_COLORS = ['#FFE5EC', '#E0F7FA', '#FFF3E0', '#E8F5E9', '#F3E5F5']

const OurTeamContacts = () => {
  const distID = localStorage.getItem('distributorId')
  const { data, error, isLoaded } = GetRequest(`/User/GetTeamContactsForDistributor/${distID}`)

  if (error) return <Error data="Team Contacts" />
  if (!isLoaded) return <Loading />

  return (
    <section className="content">
      {/* Section Header */}
      <div className="header-gradient text-white text-center py-5 mb-5">
        <h2 className="display-5 fw-bold">Our Team</h2>
        <p className="lead">Key people you can reach out to for any assistance</p>
      </div>

      {/* Team Cards with patterned background */}
      <div className="bg-pattern py-5">
        <div className="container">
          <div className="row gx-4 gy-5">
            {data.result.map((item, idx) => {
              const bgColor = CARD_COLORS[idx % CARD_COLORS.length]
              return (
                <div className="col-sm-6 col-lg-4" key={idx}>
                  <div className="card h-100 shadow" style={{ backgroundColor: bgColor, border: 'none' }}>
                    <div className="card-body text-center p-4">
                      <img
                        src={item.userImage || ss3}
                        alt={item.teamMemberName}
                        className="rounded-circle mb-4 border"
                        style={{ width: 90, height: 90, objectFit: 'cover', borderColor: '#fff' }}
                      />
                      <h5 className="fw-bold mb-1">{item.teamMemberName}</h5>
                      <small className="text-dark d-block mb-3">{item.designation}</small>
                      <hr style={{ width: '40px', borderTop: '3px solid #ccc' }} />

                      <a href={`tel:${item.mobileNumber}`}
                        className="d-inline-block mt-3 text-decoration-none text-dark fw-medium"
                      >
                        <i className="fa fa-phone me-2" />{item.mobileNumber}
                      </a>

                      {item.reachOutFor && (
                        <p className="mt-3 mb-1">
                          <strong>Reach Out For:</strong>{' '}
                          <span className="text-dark">{item.reachOutFor}</span>
                        </p>
                      )}
                      {item.additionalDetails && (
                        <p className="small text-dark">{item.additionalDetails}</p>
                      )}
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>

      {/* Colorful Social Profiles */}
      <div className="social-footer text-center py-5">
        <h4 className="fw-semibold mb-4">Follow Us</h4>
        <div className="d-inline-flex gap-4">
          <a href={SOCIAL_URLS.instagram} target="_blank" rel="noreferrer" className="social-btn instagram">
            <i className="fa fa-instagram" />
          </a>
          <a href={SOCIAL_URLS.twitter} target="_blank" rel="noreferrer" className="social-btn twitter">
            <i className="fa fa-twitter" />
          </a>
          <a href={SOCIAL_URLS.facebook} target="_blank" rel="noreferrer" className="social-btn facebook">
            <i className="fa fa-facebook" />
          </a>
          <a href={SOCIAL_URLS.linkedin} target="_blank" rel="noreferrer" className="social-btn linkedin">
            <i className="fa fa-linkedin" />
          </a>
          <a href={SOCIAL_URLS.youtube} target="_blank" rel="noreferrer" className="social-btn youtube">
            <i className="fa fa-youtube-play" />
          </a>
        </div>
      </div>

      {/* Styles */}
      <style jsx>{`
        .header-gradient {
          background: linear-gradient(90deg, #ff8a65, #ffb74d);
        }
        .bg-pattern {
          background-image: url('data:image/svg+xml;utf8,<svg width="40" height="40" xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" r="2" fill="%23ddd" /></svg>');
        }
        .social-footer {
          background: #fff3e0;
        }
        .social-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 50px;
          height: 50px;
          border-radius: 50%;
          color: #fff;
          font-size: 1.4rem;
          transition: transform .2s, box-shadow .2s;
        }
        .social-btn.instagram { background: #E1306C; }
        .social-btn.twitter   { background: #1DA1F2; }
        .social-btn.facebook  { background: #1877F2; }
        .social-btn.linkedin  { background: #0077B5; }
        .social-btn.youtube   { background: #FF0000; }
        .social-btn:hover {
          transform: scale(1.1);
          box-shadow: 0 4px 12px rgba(0,0,0,0.2);
        }
      `}</style>
    </section>
  )
}

export default OurTeamContacts
